import { AccruedInterestsContext, useCreateAccruedInterestsContext } from './AccruedInterests.context'

export const AccruedInterestsProvider = ({ children }: React.PropsWithChildren) => {
  const context = useCreateAccruedInterestsContext()
  return <AccruedInterestsContext.Provider value={context}>{children}</AccruedInterestsContext.Provider>
}
